<template>
<div class="absolute top-0 left-0 bb-zindex1 bb-bc10 bb-h100vh bb-w100vw bb-fullscreen bb-usnone"
 @click="highlightCancelBtn">
  <div class="mx-auto relative bb-vcr bb-br5 border-box p3 bb-bc11
  bb-w24pt12 bb-sm-w30 bb-mid-w35" v-on:click.stop>
    <div class="center pt2 bb-ff3 bb-fs1pt2 bb-fc16">{{ $lang.messages.logout_verification }}</div>
    <div class="clearfix center mt2">
      <div class="center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp
        bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3
        bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt2pt6"
        @click="confirmLogout">
        {{ $lang.messages.user_logout }}
      </div>
      <div class="center mt2 bb-fc2 bb-ff3 bb-pointer mb1 bb-transition2
       bb-fc8-hover bb-h1pt5 bb-lh1pt5 bb-fc14" @click="cancelLogout" :class="[
       cancelTransitionClass, cancelBtnHighlighted ? 'bb-scale-1pt2' : ''
       ]">{{ $lang.messages.cancel }}</div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'logoutModal',
  data () {
    return {
      cancelBtnHighlighted: false,
      cancelTransitionClass: 'bb-transition2'
    }
  },
  methods: {
    confirmLogout: function () {
      this.$store.commit('SET_LOGGEDIN', false)
      this.$localStorage.remove('username')
      this.$localStorage.remove('token')
      this.$localStorage.remove('profileId')
      this.cancelLogout()

      if (this.$route.name === 'Checkout') {
        this.$router.push({ name: 'Home'})
      }
    },
    highlightCancelBtn: function () {
      this.cancelBtnHighlighted = true
      var self = this
      setTimeout(function () {
        self.cancelBtnHighlighted = false
      }, this.$utilities.getTransitionDurationOfClass('.' + this.cancelTransitionClass) * 1000)
    },
    cancelLogout: function () {
      this.$store.commit('SET_SHOW_LOGOUT_MODAL', false)
      this.$emit('cancelLogoutEmit')
    },
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/logoutModal.vue